import { BaseUser } from '@orgbrain/lib-admin';
import { ContractStatus, Entity, ShareClass, StockContractType } from '../classes';

export class ContactSuggestion {
  //   firstName: string; //:     (optional if company   if given used to set contact name)
  //   lastName: string; //
  _fullName: string;
  firstName: string;
  lastName: string;
  internref: string;
  dob: any; // : string;
  address: string;
  _reason: string;
  _users?: BaseUser[];
}
export interface AdditionalContact {
  email: string;
  firstName: string;
  lastName: string;
  address?: string;
  tlf?: string;
}
export interface genericContract {
  _id?: string;
  title?: string;
  shareclass: ShareClass;
  entity: Entity;
  amount: number;
  expirationDate?: Date;
  strike: number;
  awaitingConditions: boolean;
  conditions?: string;
  type: StockContractType;
  direntId?: string;
  attachments?: any[];
  status?: ContractStatus; // ENUM

  size?: number;
  convertiblePart?: number;
  interestPerYear?: number;
  latePaymentIntereset?: number;
  // nominal interest might be important
  paymentStructure?: string;
}
export enum EmissionStep {
  KEY_INFORMATION = 'KEY_INFORMATION',
  CREATE_ORDER_FORM = 'CREATE_ORDER_FORM',
  INVITE_INVESTORS = 'INVITE_INVESTORS',
  ALLOCATE_SHARES = 'ALLOCATE_SHARES',
  CONFIRM_EMISSION = 'CONFIRM_EMISSION',
}

export enum GenericRowType {
  SAVED = 'SAVED',
  TAX = 'TAX',
  BISNODE = 'BISNODE',
  CSV = 'CSV',
}
export enum OrgNrDobLenght {
  DOB = 6,
  DOBYEAR = 8,
  DOBANDPNR = 11,
  ORGNR = 7,
  EMPTY = 0,
}

// Order is important. If we find headers we assume that type
export enum OrganizationTypeForOwners {
  COMPANY = 'COMPANY',
  SCHOOL = 'SCHOOL',
}

export class GenericData {
  companyname: string; //            (if company)
  firstname: string; //:     (optional if company   if given used to set contact name)
  lastname: string; //      (same as firstname)
  email: string; //
  dob: string; //              (if not company)
  orgnr: string; //           (if company)
  address: string; //
  _notes: string;
  internref: string;
  type: GenericRowType;

  _color: string;
  _contacts: ContactSuggestion[];
  _emailsuggestions: string[];
  _shareclass: string;
  _amount: number;
  percent: string;
  _dirty: boolean;
  master: any;
  additionalContacts?: any[];
  orgnrdob?: string;
  banknr?: string;
  records?: any[];
  name?: string;
  tlf?: string;
  pnr?: string;
  zip?: string;
  city?: string;
  country?: string;
  accounttype?: string;
  _linenumber?: number;
  shareclasses?: any[];
  extraContacts?: boolean;
  //contract fields
  additionalContracts?: any[];
  contractedAmount?: number;
  contractExpiryDate?: string;
  contractTitle?: string;
  contractType?: string;
  strikePrice?: string;
  totalLoan?: string;
  effectiveInterestRate?: string;
  convertibleShareOfLoan?: string;
  contractTerms?: string;
  contractPaymentStructure?: string;
  contractStatus?: string;
  contractConditions?: string;
  isContractField?: boolean;
}

export class GenericEntityImportData {
  companyname: string; //            (if company)
  firstname: string; //:     (optional if company   if given used to set contact name)
  lastname: string; //      (same as firstname)
  email: string; //
  dob: string; //              (if not company)
  orgnr: string; //           (if company)
  address: string; //
  internref: string;
  type: GenericRowType;

  _color: string;
  _emailsuggestions: string[];
  master: any;
  additionalContacts?: any[];
  orgnrdob?: string;
  banknr?: string;
  records?: any[];
  name?: string;
  tlf?: string;
  pnr?: string;
  zip?: string;
  city?: string;
  country?: string;
  accounttype?: string;
  _linenumber?: number;
  shareclasses?: any[];
  extraContacts?: string;
}

export enum defaultHeadersEnum {
  'companyname' = 'companyname',
  'orgnr' = 'orgnr',
  'orgnrdob' = 'orgnrdob',
  'firstname' = 'firstname',
  'lastname' = 'lastname',
  'name' = 'name',
  'dob' = 'dob',
  'pnr' = 'pnr',
  'email' = 'email',
  'tlf' = 'tlf',
  'address' = 'address',
  'zip' = 'zip',
  'city' = 'city',
  'country' = 'country',
  'shares' = 'shares',
  'notes' = 'notes',
  'shareclass' = 'shareclass',
  'sharenumbers' = 'sharenumbers',
  'banknr' = 'banknr',
  'vps' = 'vps',
  'lei' = 'lei',
  'extraContacts' = 'extraContacts',
  membershipnumber = 'membershipnumber',
  accounttype = 'accounttype',
  contractedAmount = 'contractedAmount',
  contractExpiryDate = 'contractExpiryDate',
  contractTitle = 'contractTitle',
  contractType = 'contractType',
  strikePrice = 'strikePrice',
  totalLoan = 'totalLoan',
  effectiveInterestRate = 'effectiveInterestRate',
  convertibleShareOfLoan = 'convertibleShareOfLoan',
  contractTerms = 'contractTerms',
  contractPaymentStructure = 'contractPaymentStructure',
  contractStatus = 'contractStatus',
}

export const defaultHeaders = Object.keys(defaultHeadersEnum);

export const defaultShareClass = {
  ESEK: 'Ordinær seksjon',
  BRL: 'Ordinær andel',
  FLI: 'Ordinært medlem',
  NIF: 'Ordinært medlem',
  BA: 'Ordinært medlem',
  SA: 'Ordinært medlem',
  STI: 'Ordinært medlem',
  FKF: 'Ordinært medlem',
  KF: 'Ordinært medlem',
  IKS: 'Ordinært medlem',
  IKSR: 'Medlem',
  SBSTI: 'Ordinært medlem',
  ANS: 'Ordinært medlem',
  DA: 'Ordinært medlem',
  AS: 'Ordinære aksjer',
  ASA: 'Ordinære aksjer',
};

export const headerMaps = {
  [defaultHeadersEnum.companyname]: [
    'membername',
    'navnpåorganisasjon',
    'organisasjonsnavn',
    'nameoforganization',
  ],
  [defaultHeadersEnum.orgnr]: ['orgnr', 'orgnummer', 'organisasjonsnummer'],
  [defaultHeadersEnum.orgnrdob]: ['orgnr/dob', 'investorid', 'fødselsdatoeller/org.nr'],
  [defaultHeadersEnum.firstname]: ['fornavn', 'firstname'],
  [defaultHeadersEnum.lastname]: ['etternavn', 'lastname'],
  [defaultHeadersEnum.email]: [
    'e-post',
    'email',
    'e-mail',
    'epost',
    'e-mailaddress',
    'e-postaddresse',
    'e-postadresse',
    'epostaddresse',
    'epostadresse',
    'emailaddress',
  ],
  [defaultHeadersEnum.dob]: ['dateofbirth', 'fødselsdato', 'fødselsnummer', 'dob'],
  [defaultHeadersEnum.pnr]: ['pnr', 'personnummer'],
  [defaultHeadersEnum.banknr]: ['banknummer', 'banknr', 'bankkonto'],
  [defaultHeadersEnum.shares]: [
    'antallaksjer',
    'antallstemmer',
    'holding',
    'aksjer',
    'beholdning',
    'andeler',
    'antallseksjoner',
  ],
  [defaultHeadersEnum.notes]: [
    'aksjenummer',
    'aksjenr.(fra-til)',
    'seksjonsnummer',
    'andelsnummer',
  ],
  [defaultHeadersEnum.membershipnumber]: ['medlemsnummer'],
  [defaultHeadersEnum.shareclass]: [
    'navnpåaksjeklasse',
    'medlemskategori',
    'aksjeklasse',
    'nameofshareclass',
    'shareclass',
  ],
  [defaultHeadersEnum.address]: ['adressetileier', 'adressetilmedlem', 'address', 'adresse'],

  [defaultHeadersEnum.zip]: ['zip', 'postnr', 'postcode', 'postnummer'],
  [defaultHeadersEnum.city]: ['city', 'by', 'town', 'poststed'],
  [defaultHeadersEnum.country]: ['Land', 'country', 'land'],
  [defaultHeadersEnum.name]: ['fulltnavn', 'name', 'fullname', 'navn'],
  [defaultHeadersEnum.tlf]: ['mobil', 'telefon', 'tlf', 'telefonnummer'],
  [defaultHeadersEnum.vps]: ['vps', 'vps-nummer', 'vps number'],
  [defaultHeadersEnum.lei]: ['lei', 'lei-nummer', 'lei number'],
  [defaultHeadersEnum.accounttype]: ['kontotype', 'accounttype'],
  [defaultHeadersEnum.extraContacts]: [
    'ekstra kontakter',
    'ekstra kontaktpersoner',
    'extra contacts',
  ],

  [defaultHeadersEnum.contractTitle]: ['contracttitle', 'avtaletittel', 'referanse'],
  [defaultHeadersEnum.contractedAmount]: [
    'contractedamount',
    'kontraktbeløp',
    'antaloopsjoner',
    'antalltegningsretter',
    'antallkonvertibleaksjer',
  ],
  [defaultHeadersEnum.contractExpiryDate]: [
    'contractexpirydate',
    'expirydate',
    'utløpsdato',
    'kontraktutløpsdato',
  ],
  [defaultHeadersEnum.contractType]: ['contracttype', 'kontrakttype', 'type', 'typekontrakt'],
  [defaultHeadersEnum.strikePrice]: ['strikeprice', 'innløsningskurs'],
  [defaultHeadersEnum.totalLoan]: ['totalloan', 'lånebeløp', 'totaltlån'],
  [defaultHeadersEnum.effectiveInterestRate]: ['effectiveinterestrate', 'effektivlånerente'],
  [defaultHeadersEnum.convertibleShareOfLoan]: [
    'convertibleshareOfloan',
    'konvertibelandelavlånet',
    'Konverteringsbeløp',
    'Konvertibelandelavlånet',
  ],
  [defaultHeadersEnum.contractTerms]: ['contractterms', 'betingelser'],
  [defaultHeadersEnum.contractPaymentStructure]: [
    'contractpaymentstructure',
    'betalingsstrukturtillånet',
    'lånetsbetalingsstruktur',
    'betalingsstrukturforlånet',
  ],
  [defaultHeadersEnum.contractStatus]: ['contractstatus', 'status', 'kontraktstatus'],
};

export const organizationHeaderMap = {
  ESEK: {
    [defaultHeadersEnum.companyname]: 'Navn på organisasjon',
    [defaultHeadersEnum.orgnr]: 'Organisasjonsnummer',
    [defaultHeadersEnum.orgnrdob]: 'Orgnr/fødselsdato',
    [defaultHeadersEnum.firstname]: 'Fornavn',
    [defaultHeadersEnum.lastname]: 'Etternavn',
    [defaultHeadersEnum.name]: 'Fullt navn',
    [defaultHeadersEnum.email]: 'E-post',
    [defaultHeadersEnum.dob]: 'Fødselsdato',
    [defaultHeadersEnum.pnr]: 'Personnummer',
    [defaultHeadersEnum.tlf]: 'Telefonnummer',
    [defaultHeadersEnum.address]: 'Adresse til eier',
    [defaultHeadersEnum.zip]: 'Postnr',
    [defaultHeadersEnum.city]: 'By',
    [defaultHeadersEnum.country]: 'Land',
    [defaultHeadersEnum.shares]: 'Antall seksjoner',
    [defaultHeadersEnum.notes]: 'Seksjonsnummer',
    [defaultHeadersEnum.banknr]: 'Bankkonto',
    [defaultHeadersEnum.vps]: 'VPS-nummer',
    [defaultHeadersEnum.lei]: 'LEI-nummer',
    [defaultHeadersEnum.accounttype]: 'Kontotype',
    [defaultHeadersEnum.extraContacts]: 'Ekstra kontakter',
  },
  BRL: {
    [defaultHeadersEnum.companyname]: 'Navn på organisasjon',
    [defaultHeadersEnum.orgnr]: 'Organisasjonsnummer',
    [defaultHeadersEnum.orgnrdob]: 'Orgnr/fødselsdato',
    [defaultHeadersEnum.firstname]: 'Fornavn',
    [defaultHeadersEnum.lastname]: 'Etternavn',
    [defaultHeadersEnum.name]: 'Fullt navn',
    [defaultHeadersEnum.email]: 'E-post',
    [defaultHeadersEnum.dob]: 'Fødselsdato',
    [defaultHeadersEnum.pnr]: 'Personnummer',
    [defaultHeadersEnum.tlf]: 'Telefonnummer',
    [defaultHeadersEnum.address]: 'Adresse til eier',
    [defaultHeadersEnum.zip]: 'Postnr',
    [defaultHeadersEnum.city]: 'By',
    [defaultHeadersEnum.country]: 'Land',
    [defaultHeadersEnum.shares]: 'Andeler',
    [defaultHeadersEnum.notes]: 'Andelsnummer',
    [defaultHeadersEnum.banknr]: 'Bankkonto',
    [defaultHeadersEnum.vps]: 'VPS-nummer',
    [defaultHeadersEnum.lei]: 'LEI-nummer',
    [defaultHeadersEnum.accounttype]: 'Kontotype',
    [defaultHeadersEnum.extraContacts]: 'Ekstra kontakter',
  },
  FLI: {
    [defaultHeadersEnum.companyname]: 'Navn på organisasjon',
    [defaultHeadersEnum.orgnr]: 'Organisasjonsnummer',
    [defaultHeadersEnum.orgnrdob]: 'Orgnr/fødselsdato',
    [defaultHeadersEnum.firstname]: 'Fornavn',
    [defaultHeadersEnum.lastname]: 'Etternavn',
    [defaultHeadersEnum.name]: 'Fullt navn',
    [defaultHeadersEnum.email]: 'E-post',
    [defaultHeadersEnum.dob]: 'Fødselsdato',
    [defaultHeadersEnum.pnr]: 'Personnummer',
    [defaultHeadersEnum.tlf]: 'Telefonnummer',
    [defaultHeadersEnum.address]: 'Adresse til medlem',
    [defaultHeadersEnum.zip]: 'Postnr',
    [defaultHeadersEnum.city]: 'By',
    [defaultHeadersEnum.country]: 'Land',
    [defaultHeadersEnum.shares]: 'Andeler',
    [defaultHeadersEnum.notes]: 'Medlemsnummer',
    [defaultHeadersEnum.shareclass]: 'Medlemskategori',
    [defaultHeadersEnum.banknr]: 'Bankkonto',
    [defaultHeadersEnum.accounttype]: 'Kontotype',
    [defaultHeadersEnum.extraContacts]: 'Ekstra kontakter',
  },
  NIF: {
    [defaultHeadersEnum.companyname]: 'Navn på organisasjon',
    [defaultHeadersEnum.orgnr]: 'Organisasjonsnummer',
    [defaultHeadersEnum.orgnrdob]: 'Orgnr/fødselsdato',
    [defaultHeadersEnum.firstname]: 'Fornavn',
    [defaultHeadersEnum.lastname]: 'Etternavn',
    [defaultHeadersEnum.name]: 'Fullt navn',
    [defaultHeadersEnum.email]: 'E-post',
    [defaultHeadersEnum.dob]: 'Fødselsdato',
    [defaultHeadersEnum.pnr]: 'Personnummer',
    [defaultHeadersEnum.tlf]: 'Telefonnummer',
    [defaultHeadersEnum.address]: 'Adresse til medlem',
    [defaultHeadersEnum.zip]: 'Postnr',
    [defaultHeadersEnum.city]: 'By',
    [defaultHeadersEnum.country]: 'Land',
    [defaultHeadersEnum.shares]: 'Andeler',
    [defaultHeadersEnum.membershipnumber]: 'Medlemsnummer',
    [defaultHeadersEnum.shareclass]: 'Medlemskategori',
    [defaultHeadersEnum.banknr]: 'Bankkonto',
    [defaultHeadersEnum.accounttype]: 'Kontotype',
    [defaultHeadersEnum.extraContacts]: 'Ekstra kontakter',
  },
  BA: {
    [defaultHeadersEnum.companyname]: 'Navn på organisasjon',
    [defaultHeadersEnum.orgnr]: 'Organisasjonsnummer',
    [defaultHeadersEnum.orgnrdob]: 'Orgnr/fødselsdato',
    [defaultHeadersEnum.firstname]: 'Fornavn',
    [defaultHeadersEnum.lastname]: 'Etternavn',
    [defaultHeadersEnum.name]: 'Fullt navn',
    [defaultHeadersEnum.email]: 'E-post',
    [defaultHeadersEnum.dob]: 'Fødselsdato',
    [defaultHeadersEnum.pnr]: 'Personnummer',
    [defaultHeadersEnum.tlf]: 'Telefonnummer',
    [defaultHeadersEnum.address]: 'Adresse til eier',
    [defaultHeadersEnum.zip]: 'Postnr',
    [defaultHeadersEnum.city]: 'By',
    [defaultHeadersEnum.country]: 'Land',
    [defaultHeadersEnum.shares]: 'Antall aksjer',
    [defaultHeadersEnum.notes]: 'Aksjenummer',
    [defaultHeadersEnum.shareclass]: 'Navn på aksjeklasse',
    [defaultHeadersEnum.banknr]: 'Bankkonto',
    [defaultHeadersEnum.vps]: 'VPS-nummer',
    [defaultHeadersEnum.lei]: 'LEI-nummer',
    [defaultHeadersEnum.accounttype]: 'Kontotype',
    [defaultHeadersEnum.extraContacts]: 'Ekstra kontakter',
  },
  SA: {
    [defaultHeadersEnum.companyname]: 'Navn på organisasjon',
    [defaultHeadersEnum.orgnr]: 'Organisasjonsnummer',
    [defaultHeadersEnum.orgnrdob]: 'Orgnr/fødselsdato',
    [defaultHeadersEnum.firstname]: 'Fornavn',
    [defaultHeadersEnum.lastname]: 'Etternavn',
    [defaultHeadersEnum.name]: 'Fullt navn',
    [defaultHeadersEnum.email]: 'E-post',
    [defaultHeadersEnum.dob]: 'Fødselsdato',
    [defaultHeadersEnum.pnr]: 'Personnummer',
    [defaultHeadersEnum.tlf]: 'Telefonnummer',
    [defaultHeadersEnum.banknr]: 'Bankkonto',
    [defaultHeadersEnum.address]: 'Adresse til eier',
    [defaultHeadersEnum.zip]: 'Postnr',
    [defaultHeadersEnum.city]: 'By',
    [defaultHeadersEnum.country]: 'Land',
    [defaultHeadersEnum.shares]: 'Antall stemmer',
    [defaultHeadersEnum.membershipnumber]: 'Medlemsnummer',
    [defaultHeadersEnum.shareclass]: 'Medlemskategori',
    [defaultHeadersEnum.accounttype]: 'Kontotype',
    [defaultHeadersEnum.extraContacts]: 'Ekstra kontakter',
  },
  STI: {
    [defaultHeadersEnum.companyname]: 'Navn på organisasjon',
    [defaultHeadersEnum.orgnr]: 'Organisasjonsnummer',
    [defaultHeadersEnum.orgnrdob]: 'Orgnr/fødselsdato',
    [defaultHeadersEnum.firstname]: 'Fornavn',
    [defaultHeadersEnum.lastname]: 'Etternavn',
    [defaultHeadersEnum.name]: 'Fullt navn',
    [defaultHeadersEnum.email]: 'E-post',
    [defaultHeadersEnum.dob]: 'Fødselsdato',
    [defaultHeadersEnum.pnr]: 'Personnummer',
    [defaultHeadersEnum.tlf]: 'Telefonnummer',
    [defaultHeadersEnum.address]: 'Adresse til eier',
    [defaultHeadersEnum.zip]: 'Postnr',
    [defaultHeadersEnum.city]: 'By',
    [defaultHeadersEnum.country]: 'Land',
    [defaultHeadersEnum.shares]: 'Antall aksjer',
    [defaultHeadersEnum.notes]: 'Aksjenummer',
    [defaultHeadersEnum.shareclass]: 'Navn på aksjeklasse',
    [defaultHeadersEnum.banknr]: 'Bankkonto',
    [defaultHeadersEnum.vps]: 'VPS-nummer',
    [defaultHeadersEnum.lei]: 'LEI-nummer',
    [defaultHeadersEnum.accounttype]: 'Kontotype',
    [defaultHeadersEnum.extraContacts]: 'Ekstra kontakter',
  },
  SBSTI: {
    [defaultHeadersEnum.companyname]: 'Navn på organisasjon',
    [defaultHeadersEnum.orgnr]: 'Organisasjonsnummer',
    [defaultHeadersEnum.orgnrdob]: 'Orgnr/fødselsdato',
    [defaultHeadersEnum.firstname]: 'Fornavn',
    [defaultHeadersEnum.lastname]: 'Etternavn',
    [defaultHeadersEnum.name]: 'Fullt navn',
    [defaultHeadersEnum.email]: 'E-post',
    [defaultHeadersEnum.dob]: 'Fødselsdato',
    [defaultHeadersEnum.pnr]: 'Personnummer',
    [defaultHeadersEnum.tlf]: 'Telefonnummer',
    [defaultHeadersEnum.address]: 'Adresse til eier',
    [defaultHeadersEnum.zip]: 'Postnr',
    [defaultHeadersEnum.city]: 'By',
    [defaultHeadersEnum.country]: 'Land',
    [defaultHeadersEnum.shares]: 'Antall aksjer',
    [defaultHeadersEnum.notes]: 'Aksjenummer',
    [defaultHeadersEnum.shareclass]: 'Navn på aksjeklasse',
    [defaultHeadersEnum.accounttype]: 'Kontotype',
    [defaultHeadersEnum.extraContacts]: 'Ekstra kontakter',
  },
  SBA: {
    [defaultHeadersEnum.companyname]: 'Navn på organisasjon',
    [defaultHeadersEnum.orgnr]: 'Organisasjonsnummer',
    [defaultHeadersEnum.orgnrdob]: 'Orgnr/fødselsdato',
    [defaultHeadersEnum.firstname]: 'Fornavn',
    [defaultHeadersEnum.lastname]: 'Etternavn',
    [defaultHeadersEnum.name]: 'Fullt navn',
    [defaultHeadersEnum.email]: 'E-post',
    [defaultHeadersEnum.dob]: 'Fødselsdato',
    [defaultHeadersEnum.pnr]: 'Personnummer',
    [defaultHeadersEnum.tlf]: 'Telefonnummer',
    [defaultHeadersEnum.address]: 'Adresse til eier',
    [defaultHeadersEnum.zip]: 'Postnr',
    [defaultHeadersEnum.city]: 'By',
    [defaultHeadersEnum.country]: 'Land',
    [defaultHeadersEnum.shares]: 'Antall aksjer',
    [defaultHeadersEnum.notes]: 'Aksjenummer',
    [defaultHeadersEnum.shareclass]: 'Navn på aksjeklasse',
    [defaultHeadersEnum.accounttype]: 'Kontotype',
    [defaultHeadersEnum.extraContacts]: 'Ekstra kontakter',
    [defaultHeadersEnum.contractedAmount]: 'kontraktbeløp',
    [defaultHeadersEnum.contractExpiryDate]: 'kontraktutløpsdato',
    [defaultHeadersEnum.contractTitle]: 'avtaletittel',
    [defaultHeadersEnum.contractType]: 'kontrakttype',
    [defaultHeadersEnum.strikePrice]: 'innløsningskurs',
    [defaultHeadersEnum.totalLoan]: 'Lånebeløp',
    [defaultHeadersEnum.effectiveInterestRate]: 'Effektiv lånerente',
    [defaultHeadersEnum.convertibleShareOfLoan]: 'Konverteringsbeløp',
    [defaultHeadersEnum.contractTerms]: 'betingelser',
    [defaultHeadersEnum.contractPaymentStructure]: 'betalingsstrukturtillånet',
    [defaultHeadersEnum.contractStatus]: 'kontraktstatus',
  },
  AS: {
    [defaultHeadersEnum.companyname]: 'Navn på organisasjon',
    [defaultHeadersEnum.orgnr]: 'Organisasjonsnummer',
    [defaultHeadersEnum.orgnrdob]: 'Orgnr/fødselsdato',
    [defaultHeadersEnum.firstname]: 'Fornavn',
    [defaultHeadersEnum.lastname]: 'Etternavn',
    [defaultHeadersEnum.name]: 'Fullt navn',
    [defaultHeadersEnum.email]: 'E-post',
    [defaultHeadersEnum.dob]: 'Fødselsdato',
    [defaultHeadersEnum.pnr]: 'Personnummer',
    [defaultHeadersEnum.tlf]: 'Telefonnummer',
    [defaultHeadersEnum.address]: 'Adresse til eier',
    [defaultHeadersEnum.zip]: 'Postnr',
    [defaultHeadersEnum.city]: 'By',
    [defaultHeadersEnum.country]: 'Land',
    [defaultHeadersEnum.shares]: 'Antall aksjer',
    [defaultHeadersEnum.notes]: 'Aksjenummer',
    [defaultHeadersEnum.shareclass]: 'Navn på aksjeklasse',
    [defaultHeadersEnum.banknr]: 'Bankkonto',
    [defaultHeadersEnum.vps]: 'VPS-nummer',
    [defaultHeadersEnum.lei]: 'LEI-nummer',
    [defaultHeadersEnum.accounttype]: 'Kontotype',
    [defaultHeadersEnum.extraContacts]: 'Ekstra kontakter',
  },
  ASA: {
    [defaultHeadersEnum.companyname]: 'Navn på organisasjon',
    [defaultHeadersEnum.orgnr]: 'Organisasjonsnummer',
    [defaultHeadersEnum.orgnrdob]: 'Orgnr/fødselsdato',
    [defaultHeadersEnum.firstname]: 'Fornavn',
    [defaultHeadersEnum.lastname]: 'Etternavn',
    [defaultHeadersEnum.name]: 'Fullt navn',
    [defaultHeadersEnum.email]: 'E-post',
    [defaultHeadersEnum.dob]: 'Fødselsdato',
    [defaultHeadersEnum.pnr]: 'Personnummer',
    [defaultHeadersEnum.tlf]: 'Telefonnummer',
    [defaultHeadersEnum.address]: 'Adresse til eier',
    [defaultHeadersEnum.zip]: 'Postnr',
    [defaultHeadersEnum.city]: 'By',
    [defaultHeadersEnum.country]: 'Land',
    [defaultHeadersEnum.shares]: 'Antall aksjer',
    [defaultHeadersEnum.notes]: 'Aksjenummer',
    [defaultHeadersEnum.shareclass]: 'Navn på aksjeklasse',
    [defaultHeadersEnum.banknr]: 'Bankkonto',
    [defaultHeadersEnum.vps]: 'VPS-nummer',
    [defaultHeadersEnum.lei]: 'LEI-nummer',
    [defaultHeadersEnum.accounttype]: 'Kontotype',
    [defaultHeadersEnum.extraContacts]: 'Ekstra kontakter',
  },
  Contract: {
    [defaultHeadersEnum.companyname]: 'Navn på organisasjon',
    [defaultHeadersEnum.orgnr]: 'Organisasjonsnummer',
    [defaultHeadersEnum.orgnrdob]: 'Orgnr/fødselsdato',
    [defaultHeadersEnum.firstname]: 'Fornavn',
    [defaultHeadersEnum.lastname]: 'Etternavn',
    [defaultHeadersEnum.name]: 'Fullt navn',
    [defaultHeadersEnum.email]: 'E-post',
    [defaultHeadersEnum.dob]: 'Fødselsdato',
    [defaultHeadersEnum.pnr]: 'Personnummer',
    [defaultHeadersEnum.tlf]: 'Telefonnummer',
    [defaultHeadersEnum.address]: 'Adresse til eier',
    [defaultHeadersEnum.zip]: 'Postnr',
    [defaultHeadersEnum.city]: 'By',
    [defaultHeadersEnum.country]: 'Land',
    [defaultHeadersEnum.shares]: 'Antall aksjer',
    [defaultHeadersEnum.notes]: 'Aksjenummer',
    [defaultHeadersEnum.shareclass]: 'Navn på aksjeklasse',
    [defaultHeadersEnum.banknr]: 'Bankkonto',
    [defaultHeadersEnum.vps]: 'VPS-nummer',
    [defaultHeadersEnum.lei]: 'LEI-nummer',
    [defaultHeadersEnum.accounttype]: 'Kontotype',
    [defaultHeadersEnum.extraContacts]: 'Ekstra kontakter',
    [defaultHeadersEnum.contractedAmount]: 'Kontraktbeløp',
    [defaultHeadersEnum.contractExpiryDate]: 'Kontrakt utløpsdato',
    [defaultHeadersEnum.contractTitle]: 'Avtaletittel',
    [defaultHeadersEnum.contractType]: 'Kontraktstype',
    [defaultHeadersEnum.strikePrice]: 'Innløsningskurs',
    [defaultHeadersEnum.totalLoan]: 'Lånebeløp',
    [defaultHeadersEnum.effectiveInterestRate]: 'Effektiv lånerente',
    [defaultHeadersEnum.convertibleShareOfLoan]: 'Konverteringsbeløp',
    [defaultHeadersEnum.contractTerms]: 'Betingelser',
    [defaultHeadersEnum.contractPaymentStructure]: 'Lånets betalingsstruktur',
    [defaultHeadersEnum.contractStatus]: 'Kontrakt status',
  },
  emission: {
    [defaultHeadersEnum.companyname]: 'Navn på organisasjon',
    [defaultHeadersEnum.orgnr]: 'Organisasjonsnummer',
    [defaultHeadersEnum.orgnrdob]: 'Orgnr/fødselsdato',
    [defaultHeadersEnum.firstname]: 'Fornavn',
    [defaultHeadersEnum.lastname]: 'Etternavn',
    [defaultHeadersEnum.name]: 'Fullt navn',
    [defaultHeadersEnum.email]: 'E-post',
    [defaultHeadersEnum.dob]: 'Fødselsdato',
    [defaultHeadersEnum.pnr]: 'Personnummer',
    [defaultHeadersEnum.tlf]: 'Telefonnummer',
    [defaultHeadersEnum.address]: 'Adresse til eier',
    [defaultHeadersEnum.zip]: 'Postnr',
    [defaultHeadersEnum.city]: 'By',
    [defaultHeadersEnum.country]: 'Land',
    [defaultHeadersEnum.shares]: 'Antall aksjer',
    [defaultHeadersEnum.banknr]: 'Bankkonto',
    [defaultHeadersEnum.vps]: 'VPS-nummer',
    [defaultHeadersEnum.lei]: 'LEI-nummer',
    [defaultHeadersEnum.accounttype]: 'Kontotype',
    [defaultHeadersEnum.extraContacts]: 'Ekstra kontakter',
  },
};
export const organizationHeaderContractMap = {
  Contract: {
    [defaultHeadersEnum.companyname]: 'Navn på organisasjon',
    [defaultHeadersEnum.orgnr]: 'Organisasjonsnummer',
    [defaultHeadersEnum.orgnrdob]: 'Orgnr/fødselsdato',
    [defaultHeadersEnum.firstname]: 'Fornavn',
    [defaultHeadersEnum.lastname]: 'Etternavn',
    [defaultHeadersEnum.name]: 'Fullt navn',
    [defaultHeadersEnum.email]: 'E-post',
    [defaultHeadersEnum.dob]: 'Fødselsdato',
    [defaultHeadersEnum.pnr]: 'Personnummer',
    [defaultHeadersEnum.tlf]: 'Telefonnummer',
    [defaultHeadersEnum.address]: 'Adresse til eier',
    [defaultHeadersEnum.zip]: 'Postnr',
    [defaultHeadersEnum.city]: 'By',
    [defaultHeadersEnum.country]: 'Land',
    [defaultHeadersEnum.shares]: 'Antall aksjer',
    [defaultHeadersEnum.notes]: 'Aksjenummer',
    [defaultHeadersEnum.shareclass]: 'Navn på aksjeklasse',
    [defaultHeadersEnum.banknr]: 'Bankkonto',
    [defaultHeadersEnum.vps]: 'VPS-nummer',
    [defaultHeadersEnum.lei]: 'LEI-nummer',
    [defaultHeadersEnum.accounttype]: 'Kontotype',
    [defaultHeadersEnum.extraContacts]: 'Ekstra kontakter',
    [defaultHeadersEnum.contractedAmount]: 'Kontraktbeløp',
    [defaultHeadersEnum.contractExpiryDate]: 'Kontrakt utløpsdato',
    [defaultHeadersEnum.contractTitle]: 'Avtaletittel',
    [defaultHeadersEnum.contractType]: 'Kontraktstype',
    [defaultHeadersEnum.strikePrice]: 'Innløsningskurs',
    [defaultHeadersEnum.totalLoan]: 'Lånebeløp',
    [defaultHeadersEnum.effectiveInterestRate]: 'Effektiv lånerente',
    [defaultHeadersEnum.convertibleShareOfLoan]: 'Konverteringsbeløp',
    [defaultHeadersEnum.contractTerms]: 'Betingelser',
    [defaultHeadersEnum.contractPaymentStructure]: 'Lånets betalingsstruktur',
    [defaultHeadersEnum.contractStatus]: 'Kontrakt status',
  },
};
export const translatedStatus = {
  not_exercised: [
    'ikke utøvd',
    'not exercised',
    'not_exercised',
    'notexercised',
    'ikkeutøvd',
    'ikkeutovd',
    'ikke_utøvd',
  ],
  cancelled: ['kansellert', 'cancelled'],
  expired: ['utløpt', 'expired'],
  exercised: ['utøvd', 'exercised'],
};
export const translatedType = {
  option: ['opsjon', 'option'],
  warrant: ['warrant', 'tegningsrett'],
  convertible: ['konvertibel', 'convertible', 'lån'],
};
export const EXCLUDED_TEMPLATE_HEADERS = ['orgnrdob', 'name'];
export const EXCLUDED_INVESTOR_TEMPLATE_HEADERS = [
  'orgnrdob',
  'name',
  'shares',
  'notes',
  'shareclass',
];
export const EXCLUDED_EXPORT_HEADERS = [
  'orgnrdob',
  'name',
  'tlf',
  'email',
  'pnr',
  'address',
  'country',
  'vps',
  'lei',
  'zip',
  'city',
  'contractedAmount',
  'contractExpiryDate',
  'contractTitle',
  'contractType',
  'strikePrice',
  'totalLoan',
  'effectiveInterestRate',
  'convertibleShareOfLoan',
  'contractTerms',
  'contractPaymentStructure',
  'contractStatus',
];
//contractedAmount = 'contractedAmount',
//  contractExpiryDate = 'contractExpiryDate',
//  contractTitle = 'contractTitle',
//  contractType = 'contractType',
//  strikePrice = 'strikePrice',
//  totalLoan = 'totalLoan',
//  effectiveInterestRate = 'effectiveInterestRate',
//  convertibleShareOfLoan = 'convertibleShareOfLoan',
//  contractTerms = 'contractTerms',
//  contractPaymentStructure = 'contractPaymentStructure',
//  contractStatus
export const EXCLUDED_EXPORT_HEADERS_EXTRA_FIELDS = [
  'orgnrdob',
  'name',
  'contractedAmount',
  'contractExpiryDate',
  'contractTitle',
  'contractType',
  'strikePrice',
  'totalLoan',
  'effectiveInterestRate',
  'convertibleShareOfLoan',
  'contractTerms',
  'contractPaymentStructure',
  'contractStatus',
];
export const EXCLUDED_EXPORT_HEADERS_CONTRACT_EXTRA_FIELDS = [
  'orgnrdob',
  'name',
  'shares',
  'notes',
];

for (const key of Object.keys(organizationHeaderMap)) {
  const row = organizationHeaderMap[key];
  for (const headerKey of Object.keys(row)) {
    const header = row[headerKey];
    const trimmed_header = header.toLowerCase().replace(/ /g, '');
    if (headerMaps[headerKey].indexOf(trimmed_header) === -1) {
      headerMaps[headerKey].push(trimmed_header);
    }
  }
}
